import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  QueryList,
  ViewChildren,
  ElementRef,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacypolicies',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './privacypolicies.component.html',
  styleUrls: ['./privacypolicies.component.scss'],
})
export class PrivacypoliciesComponent implements OnInit, AfterViewInit, OnDestroy {
  private translate = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);
  private previousLang!: string;
  @ViewChildren('section') sectionElements!: QueryList<ElementRef>;
  activeIndex = 0;
  sections = [
    { id: 'privacy', label: 'privacy.index.privacyPolicy' },
    { id: 'information', label: 'privacy.index.informationCollectionAndUse' },
    { id: 'typesOfDataCollected', label: 'privacy.index.typesOfDataCollected' },
    { id: 'useOfData', label: 'privacy.index.useOfData' },
    { id: 'transferOfData', label: 'privacy.index.transferOfData' },
    { id: 'disclosureOfData', label: 'privacy.index.disclosureOfData' },
    { id: 'legalRequirements', label: 'privacy.index.legalRequirements' },
    { id: 'securityOfData', label: 'privacy.index.securityOfData' },
    { id: 'serviceProviders', label: 'privacy.index.serviceProviders' },
    { id: 'linksToOtherSites', label: 'privacy.index.linksToOtherSites' },
    { id: 'childrensPrivacy', label: 'privacy.index.childrensPrivacy' },
    { id: 'changesToThisPrivacyPolicy', label: 'privacy.index.changesToThisPrivacyPolicy' },
    { id: 'contactUs', label: 'privacy.index.contactUs' },
  ];

  private observer!: IntersectionObserver;

  ngOnInit() {
    this.previousLang = this.translate.currentLang;
    this.translate.use('en');
  }

  ngAfterViewInit() {
    this.initObserver();
  }

  private initObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = this.sectionElements
              .toArray()
              .findIndex((el) => el.nativeElement === entry.target);
            if (index !== -1) {
              this.activeIndex = index;
              this.cdr.detectChanges();
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0,
      }
    );

    this.sectionElements.forEach((section) => {
      this.observer.observe(section.nativeElement);
    });
  }

  ngOnDestroy() {
    this.translate.use(this.previousLang);
    this.observer?.disconnect();
  }
}
